import { gql, TypedDocumentNode } from 'apollo-angular';

import { IRequestMagicTokenData } from '@shared/models/magic-token';

export const REQUEST_MAGIC_TOKEN: TypedDocumentNode<IRequestMagicTokenData> = gql`
  query requestMagicToken {
    requestMagicToken
  }
`;
